import * as React from 'react';
import { connect } from 'react-redux';
import { Promise } from 'es6-promise';
import { ActionConfig } from '../components';
import store from '../store/store';
import types from '../store/types';
import {
	PropertyHelper, IAction, IdHelper, ActionHelper, EModalType, IOutputValue, ModalHelper, OutputsHelper, IFieldConfig, IFieldDictionary, getActionTemplate, clone,
	ComponentHelper, IValidationMessage, IValidationResponse, IComponent, EConfirmationOperationType, IProperty, IOutput, EOutputScope, tinymce
} from '../helpers';
import { IDropdownOption, TextField } from 'office-ui-fabric-react';

class ActionConfigContainer extends React.Component<any, any> {

	setModalWarningMessages = (warningMessages: string[]) => {
		store.dispatch({
			type: types.SET_MODAL_WARNING_MESSAGES,
			warningMessages: warningMessages
		});
		ModalHelper.scrollToErrorDisplay();
	}

	// Update properties for action
	updateProperty = (key: string, value: any) => {

		store.dispatch({
			type: types.SET_IS_PROPERTY_CHANGED,
			value: true
		});

		let previousLabel = PropertyHelper.getPropertyValue(this.props.state.action.Properties, 'Label');
		let action = PropertyHelper.updateProperty(this.props.state.action, key, value);
		PropertyHelper.resolveAdjustedFields(action.Properties, this.props.propertyFilters, key, value, true);

		if (action.OutputValues) {
			let primaryOutput = action.OutputValues[0];

			if (key === 'Label' && ActionHelper.shouldOverwriteOutputName(primaryOutput.Name, previousLabel)) {
				action.OutputValues[0].Name = value;
			}
		}

		store.dispatch({
			type: types.UPDATE_ACTION_DIALOG,
			action: action,
			fieldConfigs: this.props.state.fieldConfigs
		});

	}

	// Update properties for action with Create Record option
	updateEntityProperty = (key: string, value: any) => {

		store.dispatch({
			type: types.SET_IS_PROPERTY_CHANGED,
			value: true
		});

		let previousLabel = PropertyHelper.getPropertyValue(this.props.state.action.Properties, 'Label');
		let action = PropertyHelper.updateProperty(this.props.state.action, key, value);
		PropertyHelper.resolveAdjustedFields(action.Properties, this.props.propertyFilters, key, value, true);

		if (action.OutputValues) {
			let primaryOutput = action.OutputValues[0];

			if (key === 'Label' && ActionHelper.shouldOverwriteOutputName(primaryOutput.Name, previousLabel)) {
				action.OutputValues[0].Name = value;
			}
		}

		// If the changed value comes from Entity Name field, fetch necessary fields for the selected entity name.
		// Store the fields in the state to update the values in the Fields Name dropdown.
		if (key === 'Entity Name') {
			this.loadEntityFields(value, this.props.state.componentId)
			// this.loadEntityViews(value)
			this.setEntityOutput(action, value);
		}

		// Update state action along with fieldConfigs
		store.dispatch({
			type: types.UPDATE_ACTION_ENTITY_DIALOG,
			action: action
		});
	}

	// Update properties for action with Get Record option
	updateGetRecordEntityProperty = (key: string, value: any) => {

		store.dispatch({
			type: types.SET_IS_PROPERTY_CHANGED,
			value: true
		});

		let previousLabel = PropertyHelper.getPropertyValue(this.props.state.action.Properties, 'Label');
		let action = PropertyHelper.updateProperty(this.props.state.action, key, value);
		PropertyHelper.resolveAdjustedFields(action.Properties, this.props.propertyFilters, key, value, true);

		if (action.OutputValues) {
			let primaryOutput = action.OutputValues[0];

			if (key === 'Label' && ActionHelper.shouldOverwriteOutputName(primaryOutput.Name, previousLabel)) {
				action.OutputValues[0].Name = value;
			}
		}

		// If the changed value comes from Entity Name field, fetch necessary fields for the selected entity name.
		// Store the fields in the state to update the values in the Fields Name dropdown.
		if (key === 'Entity Name') {
			this.setEntityOutput(action, value);
		}

		// Update state action along with fieldConfigs
		store.dispatch({
			type: types.UPDATE_ACTION_ENTITY_DIALOG,
			action: action
		});
	}

	// Update properties for action with Create Record option
	changeEntityView = (key: string, value: any) => {

		store.dispatch({
			type: types.SET_IS_PROPERTY_CHANGED,
			value: true
		});

		let previousLabel = PropertyHelper.getPropertyValue(this.props.state.action.Properties, 'Label');
		let action = PropertyHelper.updateProperty(this.props.state.action, key, value);
		PropertyHelper.resolveAdjustedFields(action.Properties, this.props.propertyFilters, key, value, true);

		if (action.OutputValues) {
			let primaryOutput = action.OutputValues[0];

			if (key === 'Label' && ActionHelper.shouldOverwriteOutputName(primaryOutput.Name, previousLabel)) {
				action.OutputValues[0].Name = value;
			}
		}

		// If the changed value comes from Entity Name field, fetch necessary fields for the selected entity name.
		// Store the fields in the state to update the values in the Fields Name dropdown.
		if (key === 'Entity Name') {
			this.loadEntityViews(value)
			// this.setEntityOutput(action, value);
		}

		// Update state action along with fieldConfigs
		store.dispatch({
			type: types.UPDATE_ACTION_ENTITY_DIALOG,
			action: action
		});
	}

	// For UI defined outputs, retrieve all the attributes for an entity and map values of existing outputs if any.
	// Notice that the value for state variable entityOutputs is set here. entityOutput is only used for hydrating the Outputs UI section.
	setEntityOutput(action: IAction, value: any) {

		if (action.ActionType && action.ActionType.HasUIDefinedOutputs) {
			this.loadOutputFields(value, action.ComponentId).then(x => {

				const outputArray: IOutput[] = Object.keys(x).map((element, index) => ({
					Id: IdHelper.newGuid(),
					componentId: this.props.state.componentId,
					FriendlyName: this.props.state.entityFields[element].friendlyName,
					Name: this.props.state.entityFields[element].friendlyName,
					Type: this.props.state.entityFields[element].valueType,
					ValueType: this.props.state.entityFields[element].valueType,
					GlobalOutputId: '',
					LogicalName: element,
					IsRequiredGlobalOutput: false,
					DisablePrepopulatedValue: false,
					OutputScope: EOutputScope.Local,
					IsHidden: false,
					IsImmutable: true,
					StaticName: element,
				}));

				// check if the selected entity is from the journeystate. if true, set the output values accordingly
				const prevEntity = store.getState().processState.components[action.ComponentId] && store.getState().processState.components[action.ComponentId].Action.Properties.filter(x => x.Name === "Entity Name");
				if (prevEntity && prevEntity.length && prevEntity[0].Value === value) {
					action.OutputValues = store.getState().processState.components[action.ComponentId].Action.OutputValues;
					store.dispatch({
						type: types.SET_ACTION_OUTPUT_ARRAY,
						outputs: action.OutputValues
					});

				}

				if (action.OutputValues) {
					action.OutputValues.forEach(x => {
						outputArray.filter(y => y.LogicalName === x.LogicalName).length ?
							outputArray.filter(y => y.LogicalName === x.LogicalName)[0].PrepopulatedValue = x.PrepopulatedValue : null;
					});
				}

				store.dispatch({
					type: types.SET_ENTITY_OUTPUTS,
					outputs: outputArray
				});

				store.dispatch({
					type: types.SORT_ENTITY_OUTPUTS,
					outputs: outputArray,
					modalOutputs: action.OutputValues
				});

				// store.dispatch({
				// 	type: types.SORT_ENTITY_OUTPUTS,
				// 	outputs: [...outputArray, ...store.getState().modalState.actionConfig.fetchXMLOutputs],
				// 	modalOutputs: action.OutputValues
				// });

			})
		}

	}

	// For UI defined outputs, retrieve all the views for an entity and map values of existing outputs if any.
	// Notice that the value for state variable entityviews is set here. entityOutput is only used for hydrating the Outputs UI section.
	setEntityViews(action: IAction, value: any) {

		if (action.ActionType && action.ActionType.HasUIDefinedOutputs) {
			this.loadOutputFields(value, action.ComponentId).then(x => {

				const outputArray: IOutput[] = Object.keys(x).map((element, index) => ({
					Id: IdHelper.newGuid(),
					componentId: this.props.state.componentId,
					FriendlyName: this.props.state.entityFields[element].friendlyName,
					Name: this.props.state.entityFields[element].friendlyName,
					Type: this.props.state.entityFields[element].valueType,
					ValueType: this.props.state.entityFields[element].valueType,
					GlobalOutputId: '',
					LogicalName: element,
					IsRequiredGlobalOutput: false,
					DisablePrepopulatedValue: false,
					OutputScope: EOutputScope.Local,
					IsHidden: false,
					IsImmutable: true,
					StaticName: element,
				}));

				// check if the selected entity is from the journeystate. if true, set the output values accordingly
				const prevEntity = store.getState().processState.components[action.ComponentId] && store.getState().processState.components[action.ComponentId].Action.Properties.filter(x => x.Name === "Entity Name");
				if (prevEntity && prevEntity.length && prevEntity[0].Value === value) {
					action.OutputValues = store.getState().processState.components[action.ComponentId].Action.OutputValues;
					store.dispatch({
						type: types.SET_ACTION_OUTPUT_ARRAY,
						outputs: action.OutputValues
					});

				}

				if (action.OutputValues) {
					action.OutputValues.forEach(x => {
						outputArray.filter(y => y.LogicalName === x.LogicalName).length ?
							outputArray.filter(y => y.LogicalName === x.LogicalName)[0].PrepopulatedValue = x.PrepopulatedValue : null;
					});
				}

				store.dispatch({
					type: types.SET_ENTITY_OUTPUTS,
					outputs: outputArray
				});

				store.dispatch({
					type: types.SORT_ENTITY_OUTPUTS,
					outputs: outputArray,
					modalOutputs: action.OutputValues
				});

			})
		}

	}

	hasDependentDropdown(properties: IProperty[]) {
		let dependentDropdownField = properties ? properties.filter(x => x.IsDependentDropdown) : null;
		return dependentDropdownField ? dependentDropdownField : null;
	}

	onLoad = (action: IAction, outputs?: IOutput[]) => {
		let { entityOutputs } = this.props;
		// Reset entity outputs values
		store.dispatch({
			type: types.SET_ENTITY_OUTPUTS,
			outputs: null
		});

		// Reset entity field values
		store.dispatch({
			type: types.SET_ENTITY_FIELDS,
			outputs: null
		});

		// Crete an empty Math Action by default if action is empty
		if (!action.ActionType) {
			let { actionTypes } = this.props;
			const isOnLoad = true;
			this.actionTypeChange(actionTypes.filter(option => option.key === 'Math Action')[0], isOnLoad);
		} else if (action.ActionType.NameType.toLowerCase() === 'get record') {
			const entityName = action.Properties.filter(x => x.Name.toLowerCase() === 'entity name') ? action.Properties.filter(x => x.Name.toLowerCase() === 'entity name')[0].Value : null;
			entityName ?
				this.setEntityOutput(action, entityName) :
				store.dispatch({
					type: types.SET_ENTITY_OUTPUTS,
					outputs: null
				});

			// Add outputs from FetchXML
			const fetchXML = action.Properties.filter(x => x.Name.toLowerCase() === 'fetch xml')[0];
			if (fetchXML && fetchXML.Value) {
				const fetchXMLLinkAttributes = PropertyHelper.extractLinkEntityAttributes(JSON.parse(fetchXML.Value).text);
				const fetchXMLOutputs: IOutput[] = fetchXMLLinkAttributes.map(x => {
					return {
						Id: IdHelper.newGuid(),
						componentId: this.props.state.componentId,
						FriendlyName: x,
						Name: x,
						Type: 0,
						ValueType: 0,
						GlobalOutputId: '',
						LogicalName: x,
						IsRequiredGlobalOutput: false,
						DisablePrepopulatedValue: false,
						OutputScope: EOutputScope.Local,
						IsHidden: false,
						IsImmutable: true,
						StaticName: x,
					}
				})
				store.dispatch({
					type: types.SET_FETCHXML_OUTPUTS,
					outputs: fetchXMLOutputs
				});

				// const actionEntityOutputs = store.getState().modalState.actionConfig.entityOutputs ? store.getState().modalState.actionConfig.entityOutputs : [];
				// store.dispatch({
				// 	type: types.SORT_ENTITY_OUTPUTS,
				// 	outputs: [...actionEntityOutputs, ...fetchXMLOutputs],
				// 	modalOutputs: action.OutputValues
				// });


			}
		} else if (action.ActionType.NameType.toLowerCase() === 'get records') {
			const entityName = action.Properties.filter(x => x.Name.toLowerCase() === 'entity name') ? action.Properties.filter(x => x.Name.toLowerCase() === 'entity name')[0].Value : null;
			entityName ?
				this.loadEntityViews(entityName) :
				store.dispatch({
					type: types.SET_ENTITY_OUTPUTS,
					outputs: null
				});
			;
		}

		store.dispatch({
			type: types.SET_IS_PROPERTY_CHANGED,
			value: false
		});

		store.dispatch({
			type: types.SET_IS_FIELD_CHANGED,
			value: false
		});

		// Sync valueoptions of the dependent dropdown field and state entity option set
		let dependentDropdown: any = this.hasDependentDropdown(action.Properties);

		for (var dd of dependentDropdown) {
			if (action.Properties && dd) {
				if (dd.Name === 'State Code') {
					store.dispatch({
						type: types.ADD_ENTITY_STATE_CODE,
						entityStateCode: dependentDropdown.ValueOptions
					});
				} else if (dd.Name === 'Status Reason') {
					store.dispatch({
						type: types.ADD_STATUS_REASON_SET,
						entityOptionSet: dependentDropdown.ValueOptions
					});
				}
			} else {
				// reset the state values of state coded and entity option set
				store.dispatch({
					type: types.ADD_ENTITY_STATE_CODE,
					entityStateCode: null
				});
				store.dispatch({
					type: types.ADD_ENTITY_OPTION_SET,
					entityStateCode: null
				});

			}
		}

		// if the action has entity name, load its corresponding values.
		// if (action.Properties && action.Properties.length >= 3 && action.Properties[2].Name === 'Entity Name') {
		// 	ActionHelper.loadEntityFields(action.Properties[2].Value, true).then(entityFields => {
		// 		console.log(entityFields);
		// 	});
		// }

		//sort out the type dropdown tab index       
		let typeDropdown = document.querySelector('.pivotItem .ms-Dropdown');
		if (typeDropdown) {
			typeDropdown.setAttribute('tabindex', '1');
		}
	}

	loadEntityFields = (name: string, componentId: string): Promise<any> => {

		let promise = new Promise<IAction>((resolve, reject) => {
			if (this.props.entityFields && this.props.entityFields[name]) {
				resolve(clone(this.props.entityFields[name]));
			}
			else {
				return ActionHelper.loadEntityFields(name, componentId)
					.then(entityFields => {
						resolve(entityFields)
					});
			}
		});

		return promise;
	}

	loadEntityViews = (name: string): Promise<any> => {

		let promise = new Promise<IAction>((resolve, reject) => {
			if (this.props.entityFields && this.props.entityFields[name]) {
				resolve(clone(this.props.entityFields[name]));
			}
			else {
				return ActionHelper.loadEntityViews(name)
					.then(entityFields => {
						resolve(entityFields)
					});
			}
		});

		return promise;
	}

	loadOutputFields = (name: string, componentId: string): Promise<any> => {

		let promise = new Promise<IAction>((resolve, reject) => {
			if (this.props.entityFields && this.props.entityFields[name]) {
				resolve(clone(this.props.entityFields[name]));
			}
			else {
				return ActionHelper.loadEntityFields(name, componentId)
					.then(entityFields => {
						resolve(entityFields)
					});
			}
		});

		return promise;
	}

	loadActionTemplate = (name: string): Promise<IAction> => {

		let promise = new Promise<IAction>((resolve, reject) => {
			if (this.props.actionTemplates[name]) {
				resolve(clone(this.props.actionTemplates[name]));
			}
			else {
				return ActionHelper.loadActionTemplate(name)
					.then(actionTemplate => resolve(actionTemplate));
			}
		});

		return promise;
	}

	actionTypeChange = (item: IDropdownOption, isOnLoad?: boolean) => {

		let action = this.props.state.action;

		PropertyHelper.clearPropertyFilterState();

		store.dispatch({
			type: types.SET_LOADING_TEMPLATE,
			loadingTemplate: item.key
		});

		this.loadActionTemplate(item.key as string)
			.then(actionTemplate => {

				//keep the value of the Action Name property
				let actionName: string = '';
				let actionNameProperty = action.Properties.filter((v) => {
					return v.Name === 'Action Name';
				})[0];
				actionName = actionNameProperty ? actionNameProperty.Value : '';

				actionTemplate.Properties = actionTemplate.Properties.map((v) => {
					if (v.Name === 'Action Name') {
						v.Value = actionName;
					}
					return v;
				});

				actionTemplate.OutputValues = actionTemplate.OutputValues.map((v) => {
					v.Id = IdHelper.newGuid();
					return v;
				});

				store.dispatch({
					type: types.DELETE_ACTION_OUTPUTS,
					outputs: action.OutputValues
				});

				store.dispatch({
					type: types.SET_MODAL_ERROR_MESSAGES,
					errorMessages: []
				});

				store.dispatch({
					type: types.UPDATE_ACTION_DIALOG,
					action: actionTemplate
				});

				PropertyHelper.updatePropertyFilterState(actionTemplate.Properties);

				store.dispatch({
					type: types.SET_LOADING_TEMPLATE,
					loadingTemplate: null
				});

				if (isOnLoad !== true) {
					store.dispatch({
						type: types.SET_IS_PROPERTY_CHANGED,
						value: true
					});
				}

			});
	}

	entityChange = (item: IDropdownOption) => {

		let action = this.props.state.action;

		PropertyHelper.clearPropertyFilterState();

		store.dispatch({
			type: types.SET_LOADING_TEMPLATE,
			loadingTemplate: item.key
		});

		this.loadActionTemplate(item.key as string)
			.then(actionTemplate => {

				//keep the value of the Action Name property
				let actionName: string = '';
				let actionNameProperty = action.Properties.filter((v) => {
					return v.Name === 'Action Name';
				})[0];
				actionName = actionNameProperty ? actionNameProperty.Value : '';

				actionTemplate.Properties = actionTemplate.Properties.map((v) => {
					if (v.Name === 'Action Name') {
						v.Value = actionName;
					}
					return v;
				});

				actionTemplate.OutputValues = actionTemplate.OutputValues.map((v) => {
					v.Id = IdHelper.newGuid();
					return v;
				});

				store.dispatch({
					type: types.DELETE_ACTION_OUTPUTS,
					outputs: action.OutputValues
				});

				store.dispatch({
					type: types.SET_MODAL_ERROR_MESSAGES,
					errorMessages: []
				});

				store.dispatch({
					type: types.UPDATE_ACTION_DIALOG,
					action: actionTemplate
				});

				PropertyHelper.updatePropertyFilterState(actionTemplate.Properties);

				store.dispatch({
					type: types.SET_LOADING_TEMPLATE,
					loadingTemplate: null
				});
			});

	}

	syncDependentField(dependentDropdownSource: string, dependentDropdown: string, stateValue: IDropdownOption[], state: any) {
		let dependentOptionSetField;
		if (state.action.ActionType.NameType === dependentDropdownSource) {
			dependentOptionSetField = state.action.Properties.filter(x => x.Name === dependentDropdown);
		}
		if (dependentOptionSetField) {
			dependentOptionSetField[0].ValueOptions = stateValue;
			state.action.Properties.filter(x => x.Name === dependentDropdown)[0].ValueOptions = stateValue;
		}
	}

	closeDialog = (save?: boolean) => {

		let { state, isSharedJourney, parentLoopId } = this.props;

		if (save) {

			let errorMessages: string[] = this.getErrorMessages();

			if (state.fieldConfigs && state.fieldConfigs.length) {
				let duplicateFieldConfigExists: boolean = false;
				state.fieldConfigs.sort((a: IFieldConfig, b: IFieldConfig) => {
					if (a === b) {
						duplicateFieldConfigExists = true;
					}
					return 0;
				});
				if (duplicateFieldConfigExists) {
					errorMessages.push('All fields must have a unique Field Name');
				}
			}

			if (errorMessages.length) {

				store.dispatch({
					type: types.SET_MODAL_ERROR_MESSAGES,
					errorMessages: errorMessages
				});

				//scroll to the top of the dialog so that the error message is visible
				ModalHelper.scrollToErrorDisplay();

			}
			else {

				// filter out fieldConfigs that have no values
				let fieldConfigsWithValues = state.fieldConfigs ? state.fieldConfigs.filter((val) =>
					val.FieldValue.length && JSON.parse(val.FieldValue).text
				) : null;

				// populate the valueoptions of dependent dropdown fields to save it in the database. The valueoptions from database is then fetched during rehydration.
				this.syncDependentField('Get CRM Entity Option Set', 'Option Set Field Name', state.entityOptionSet, state);
				this.syncDependentField('Set Record Status', 'State Code', state.entityStateCode, state);
				this.syncDependentField('Set Record Status', 'Status Reason', state.statusReason, state);

				ComponentHelper.validateComponentProperties(state.action.ActionType.NameType, state.componentId, state.action.Properties, state.action.OutputValues, fieldConfigsWithValues).then(
					(validationResponse: IValidationResponse) => {

						let errorMessages: string[] = validationResponse.errorMessages.map((e) => e.clientErrorMessage);
						let warningMessages: string[] = validationResponse.warningMessages.map((w) => w.clientErrorMessage);

						if (errorMessages.length || warningMessages.length) {
							store.dispatch({
								type: types.SET_MODAL_ERROR_MESSAGES,
								errorMessages: errorMessages
							});
							this.setModalWarningMessages(warningMessages);
							ModalHelper.scrollToErrorDisplay();
						}
						else {

							//convert fieldConfigs to fields
							if (state.fieldConfigs) {
								state.action.Fields = state.fieldConfigs.reduce(
									(acc: IFieldDictionary, val: IFieldConfig) => {

										// if (val.FieldValue) {
										acc[val.FieldName] = {
											FieldValue: val.FieldValue,
											ValueOptionsFieldValue: val.ValueOptionsFieldValue,
											FieldType: val.FieldType,
											ValueType: val.ValueType,
											FieldRequired: val.FieldRequired,
											FriendlyName: val.FriendlyName,
											LookupEntityReference: val.LookupEntityReference,
											ValueOptions: val.ValueOptions
										};
										// }
										return acc;
									}, {});
							}

							//set the isSharedJourneyOutput on all outputs if the journey is a shared one
							if (isSharedJourney && state.action.OutputValues) {
								state.action.OutputValues.forEach(o => {
									o.DisplayOnSummary = false;
								});
							}

							//set the LoopId on all outputs if the action belongs is part of a loop
							if (parentLoopId && state.action.OutputValues) {
								state.action.OutputValues.forEach(o => {
									o.LoopId = parentLoopId
								});
							}

							// Update Action Name
							let properties = ComponentHelper.getProperties(store.getState().processState.components[state.componentId]);
							let prop = properties.filter(prop => prop.Name === "Action Name")[0];
							if (!prop)
								return;
							let actionProp = state.action.Properties.filter(prop => prop.Name === "Action Name")[0];
							actionProp.Value = prop.Value;

							// get name of the action component
							const actionName = state.action.Properties.filter(x => x.Name === 'Action Name')[0].Value;

							// set prefix to the action outputs
							state.action.OutputValues && state.action.OutputValues.forEach(element => {
								if (!element.FriendlyName && state.action.ActionType.NameType.toLowerCase() === 'get record') {
									// set friendly name for entity outputs and logical name for fetch XML outputs
									const fieldConfigElement = state.fieldConfigs.filter(x => x.FieldName === element.LogicalName)[0];
									element.FriendlyName = fieldConfigElement && fieldConfigElement.FriendlyName ? fieldConfigElement.FriendlyName : element.LogicalName;

								}
								element.Name = element.FriendlyName ? element.FriendlyName + ' - ' + actionName : element.StaticName + ' - ' + actionName;

							});

							// update the component output value 
							// store.dispatch({
							// 	type: types.UPDATE_COMPONENT_OUTPUT,
							// 	componentId: state.componentId,
							// 	key: null
							// });

							let actionToUpdate = store.getState().processState.components[state.componentId].Action;
							// state.action.OutputValues[0] = actionToUpdate.OutputValues[0];
							// sync outputstate values with component output values
							if (actionToUpdate) {
								store.dispatch({
									type: types.UPDATE_ACTION_IN_OUTPUT,
									componentId: state.componentId,
									action: state.action
								})
							}


							let prevOutputs = store.getState().outputsState.outputs.filter(x => x.componentId === state.componentId).map(x => x.Id);
							let currentOutputs = state.action.OutputValues && state.action.OutputValues.map(x => x.Id);
							let deletedOutputs = currentOutputs ? prevOutputs.filter(x => currentOutputs.indexOf(x) < 0) : prevOutputs;
							let isDeletedOutputUsed = false;
							let outputsInUse = store.getState().outputsState.outputsInUse;
							Object.keys(outputsInUse).forEach(element => {
								outputsInUse[element].filter(x => deletedOutputs.includes(x)).length ? isDeletedOutputUsed = true : null;
							});
							if (deletedOutputs.length && isDeletedOutputUsed) {
								store.dispatch({
									type: types.TOGGLE_CONFIRMATION_DIALOG,
									operationType: EConfirmationOperationType.CascadeOutputValues,
									title: 'Confirm Deletion',
									message: 'One or more deleted outputs are used as value in the journey. Saving the changes will remove the values in those places. Are you sure you want to proceed?',
									isOpen: true,
									deletedOutputs: deletedOutputs,
									componentId: state.componentId,
									action: state.action,
									parentLoopId: parentLoopId
								})
							} else {

								// save the action
								store.dispatch({
									type: types.UPDATE_ACTION,
									componentId: state.componentId,
									action: state.action,
									parentLoopId: parentLoopId,
								});

								OutputsHelper.syncOutputs(deletedOutputs);

								//close the modal
								store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });

							}

						}

					}
				);

			}

		}
		else {
			//close the modal anyway
			store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
		}

	}

	getErrorMessages = (): string[] => {
		let errorMessages: string[] = [];
		if (this.props.state.action.Properties) {

			// if (this.props.state.action.ActionType.NameType === "Get Records") {
			// 	this.props.state.action.Properties.filter(x => x.Name === "Entity Name")[0].Value && this.props.state.action.Properties.filter(x => x.Name === "Views")[0].Value
			// 		?
			// 		this.props.state.action.Properties.filter(x => x.Name === "Fetch XML")[0].IsRequired = false
			// 		: null;
			// }
			errorMessages = errorMessages.concat(PropertyHelper.getErrorMessages(this.props.state.action.Properties, false));
		}
		if (this.props.state.action.OutputValues) {
			errorMessages = errorMessages.concat(OutputsHelper.getErrorMessages(this.props.state.action.OutputValues));
		}
		return errorMessages;
	}

	updateActionOutput = (index: number, name: string) => {
		store.dispatch({ type: types.UPDATE_ACTION_OUTPUT, index: index, name: name });
	}

	actionOutputBlur = (index: number, name: string, staticName: string, logicalName: string) => {
		if (!(name || name.length)) {
			let newName = staticName || logicalName;
			this.updateActionOutput(index, newName);
		}
	}

	updateSelectedGlobalOutput = (index: number, key: string) => {
		store.dispatch({
			type: types.UPDATE_ACTION_GLOBAL_OUTPUT,
			index: index,
			key: key
		});
	}

	updateSelectedOutputType = (index: number, type: number) => {
		store.dispatch({
			type: types.UPDATE_ACTION_OUTPUT_TYPE,
			index: index,
			outputType: type
		});
	}

	updateOutputDefaultValue = (index: number, defaultValue: string) => {
		store.dispatch({
			type: types.UPDATE_ACTION_OUTPUT_DEFAULT_VALUE,
			index: index,
			defaultValue: defaultValue
		});
	};
	updateGetRecordOutputDefaultValue = (logicalName: string, defaultValue: string) => {
		store.dispatch({
			type: types.UPDATE_GET_RECORD_ACTION_OUTPUT_DEFAULT_VALUE,
			logicalName: logicalName,
			defaultValue: defaultValue
		});
	};

	updateActionOutputStaticName = (index: number, staticName: string) => {
		store.dispatch({ type: types.UPDATE_ACTION_OUTPUT_STATIC_NAME, index: index, staticName: staticName });
	}

	updateActionOutputLogicalName = (index: number, logicalName: string) => {
		// Logical name cannot contain spaces. replace with "_";
		logicalName = logicalName.replace(/ /ig, "_");
		// Logical name must only consist of lower case letters, or numbers - toLower()
		logicalName = logicalName.toLowerCase();
		store.dispatch({ type: types.UPDATE_ACTION_OUTPUT_LOGICAL_NAME, index: index, logicalName: logicalName });
	}

	addActionOutput = () => {
		store.dispatch({
			type: types.ADD_ACTION_OUTPUT
		});

		ModalHelper.scrollToBottom();
	}

	addActionOutputArray = (output: IOutput) => {
		store.dispatch({
			type: types.ADD_ACTION_OUTPUT_ARRAY,
			output: output
		});

		ModalHelper.scrollToBottom();
	}

	removeActionOutputArray = (output: IOutput) => {
		store.dispatch({
			type: types.REMOVE_ACTION_OUTPUT_ARRAY,
			output: output
		});
		// store.dispatch({
		// 	type: types.DELETE_ACTION_OUTPUTS,
		// 	outputs: [output]
		// });

		ModalHelper.scrollToBottom();
	}

	deleteActionOutput = (index: number) => {
		store.dispatch({
			type: types.DELETE_ACTION_OUTPUT,
			index: index
		});
	}

	addField = () => {
		store.dispatch({
			type: types.ADD_FIELD
		});

		ModalHelper.scrollToBottom();
	}

	addFieldFromMetadata = (fieldName: string, fieldValue: string, fieldType: number, fieldRequired?: boolean, friendlyName?: string, lookupEntityReference?: string, valueOptions?: IDropdownOption[], valueOptionsFieldValue?: string) => {
		store.dispatch({
			type: types.ADD_FIELD_FROM_METADATA,
			fieldName: fieldName,
			fieldValue: fieldValue,
			valueOptionsFieldValue: valueOptionsFieldValue,
			fieldType: fieldType,
			fieldRequired: fieldRequired,
			friendlyName: friendlyName,
			lookupEntityReference: lookupEntityReference,
			valueOptions: valueOptions
		});

		ModalHelper.scrollToBottom();
	}

	updateFieldName = (index: number, name: string) => {
		store.dispatch({
			type: types.UPDATE_FIELD_NAME,
			index: index,
			name: name
		});
	}

	updateFieldValue = (index: number, value: string) => {
		store.dispatch({
			type: types.UPDATE_FIELD_VALUE,
			index: index,
			value: value
		});
	}

	updateValueOptionsFieldValue = (index: number, value: string) => {
		store.dispatch({
			type: types.UPDATE_VALUE_OPTIONS_FIELD_VALUE,
			index: index,
			value: value
		});
	}

	updateFieldType = (index: number, key: number) => {
		store.dispatch({
			type: types.UPDATE_FIELD_TYPE,
			index: index,
			fieldType: key
		});
	}

	updateFieldRequired = (index: number, key: boolean) => {
		store.dispatch({
			type: types.UPDATE_FIELD_REQUIRED,
			index: index,
			fieldRequired: key
		});
	}

	deleteField = (index: number) => {
		store.dispatch({
			type: types.DELETE_FIELD,
			index: index
		});
	}

	setAdvancedSettingsIndex = (index: number) => {

		index = index !== this.props.state.advancedSettingsIndex ? index : null;

		store.dispatch({
			type: types.UPDATE_ACTION_ADVANCED_SETTINGS_INDEX,
			advancedSettingsIndex: index
		});
	}

	getFieldsHtml = (): JSX.Element => {
		return <TextField
			type='hidden'
			label={"Test"}
			value={''}
		/>

	}

	public render() {
		let { previousOutputBlocks, action, fieldError, fieldConfigs, entityOutputs, fetchXMLOutputs, entityOptionSet, entityStateCode, statusReason, componentId } = this.props.state;

		let fields: JSX.Element[];

		fields = fieldConfigs ?
			fieldConfigs.map(this.getFieldsHtml)
			: null;


		let parentLoopId = this.props.parentLoopId;

		let dropdownOptions: IDropdownOption[] = OutputsHelper.getOutputDropdownOptions(this.props.outputs, previousOutputBlocks);
		let globalOutputDropdownOptions: IDropdownOption[] = OutputsHelper.getGlobalOutputDropdownOptions(this.props.outputs);
		let outputTypeDropdownOptions: IDropdownOption[] = OutputsHelper.getOutputTypeDropdownOptions(this.props.outputTypes);
		let outputValueDropdownOptions: IDropdownOption[] = OutputsHelper.getOutputValueDropdownOptions(action);

		if (parentLoopId) {
			// get loop Ids
			let loopOutputs: IOutputValue[] = this.props.outputs.filter((o: IOutputValue) => {
				return o.componentId === parentLoopId;
			});
			if (loopOutputs.length) {
				globalOutputDropdownOptions = globalOutputDropdownOptions.concat(loopOutputs.map(o => { return { key: o.Id, text: o.Name } }));
			}
		}
		const tst = this.props.entityFields;

		return (
			<ActionConfig
				action={action}
				fieldConfigs={fieldConfigs}
				entityOutputs={entityOutputs}
				fetchXMLOutputs={fetchXMLOutputs}
				entityOptionSet={entityOptionSet}
				entityStateCode={entityStateCode}
				statusReason={statusReason}
				fieldError={fieldError}
				fieldTypes={this.props.fieldTypes}
				dropdownOptions={dropdownOptions}
				actionTypes={this.props.actionTypes.filter(actionType => actionType.key !== "Set Shared Journey Output Value")}
				globalOutputDropdownOptions={globalOutputDropdownOptions}
				closeDialog={this.closeDialog}
				onLoad={this.onLoad}
				updateProperty={this.updateProperty}
				updateEntityProperty={this.updateEntityProperty}
				updateGetRecordEntityProperty={this.updateGetRecordEntityProperty}
				changeEntityView={this.changeEntityView}
				updateOutput={this.updateActionOutput}
				outputBlur={this.actionOutputBlur}
				updateSelectedGlobalOutput={this.updateSelectedGlobalOutput}
				updateSelectedOutputType={this.updateSelectedOutputType}
				outputTypeDropdownOptions={outputTypeDropdownOptions}
				outputValueDropdownOptions={outputValueDropdownOptions}
				updateOutputStaticName={this.updateActionOutputStaticName}
				updateOutputLogicalName={this.updateActionOutputLogicalName}
				actionTypeChange={this.actionTypeChange}
				addActionOutput={this.addActionOutput}
				addActionOutputArray={this.addActionOutputArray}
				removeActionOutputArray={this.removeActionOutputArray}
				deleteActionOutput={this.deleteActionOutput}
				addField={this.addField}
				addFieldFromMetadata={this.addFieldFromMetadata}
				updateFieldName={this.updateFieldName}
				updateFieldValue={this.updateFieldValue}
				updateValueOptionsFieldValue={this.updateValueOptionsFieldValue}
				updateFieldType={this.updateFieldType}
				updateFieldRequired={this.updateFieldRequired}
				deleteField={this.deleteField}
				setAdvancedSettingsIndex={this.setAdvancedSettingsIndex}
				advancedSettingsIndex={this.props.state.advancedSettingsIndex}
				updateOutputDefaultValue={this.updateOutputDefaultValue}
				updateGetRecordOutputDefaultValue={this.updateGetRecordOutputDefaultValue}
				loadingTemplate={this.props.state.loadingTemplate}
				propertyFilters={this.props.propertyFilters}
				setModalWarningMessages={this.setModalWarningMessages}
				entityChange={this.entityChange}
				entityFields={this.props.entityFields}
				entityViews={this.props.entityViews}
				fieldElements={fields}
			/>
		);
	}

}

let mapStateToProps = (store) => {

	let outputs: IOutputValue[] = OutputsHelper.CombineOutputs(store.outputsState.outputs, store.outputsState.globalOutputs);
	let component: IComponent = store.processState.components[store.modalState.actionConfig.componentId];
	// let parentLoopId: string = component.ParentLoopId ? component.ParentLoopId : '';

	return {
		state: store.modalState.actionConfig,
		outputs: outputs,
		outputTypes: store.cacheState.outputTypes,
		components: store.processState.components,
		actionTemplates: store.cacheState.actionTemplates,
		entityFields: store.modalState.actionConfig.entityFields,
		entityViews: store.modalState.actionConfig.entityViews,
		actionTypes: store.cacheState.actionTypes,
		outputLookupContext: store.outputsState.outputLookupContext,
		outputSearchElementId: store.outputsState.outputSearchElementId,
		outputSearchTerm: store.outputsState.outputSearchTerm,
		fieldTypes: store.cacheState.fieldTypes,
		propertyFilters: store.propertyFilterState.propertyFilters,
		isSharedJourney: store.toolsState.isSharedJourney,
		// parentLoopId: parentLoopId
	};
};

export default connect<any, any, any>(mapStateToProps)(ActionConfigContainer);



// WEBPACK FOOTER //
// ./source/ts/containers/action-config.tsx